export const mosaic = {
    label: {
        visible: !1,
        position: "center",
        style: {
            lineWidth: 2,
            stroke: {
                type: "palette",
                key: "backgroundColor"
            }
        }
    },
    bar: {
        style: {
            lineWidth: 1,
            stroke: {
                type: "palette",
                key: "backgroundColor"
            }
        }
    }
};
//# sourceMappingURL=mosaic.js.map
